import ApiClient from './ApiClient';

class SupportXDashboardSessionAPI extends ApiClient {
  constructor() {
    super('supportx_dashboard_session', { accountScoped: true });
  }
}

export default new SupportXDashboardSessionAPI();
